module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "global-meeting"
  }, [(_vm.meeting) ? _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_c('span', [_vm._v("Meeting Signup")]), _c('span', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "mentor-info"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.meeting.mentor.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('h3', [_vm._v("\n                        " + _vm._s(_vm.meeting.mentor.firstName) + " " + _vm._s(_vm.meeting.mentor.lastName) + "                      \n                    ")]), _vm._v(" "), _c('h4', [_vm._v("\n                        " + _vm._s(_vm.meeting.mentor.mentor_profile.position) + ", " + _vm._s(_vm.meeting.mentor.mentor_profile.company) + "\n                    ")]), _vm._v(" "), (_vm.meeting.mentor.website) ? _c('p', [_c('a', {
    attrs: {
      "href": _vm.meeting.mentor.website,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.meeting.mentor.website))])]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.meeting.mentor.mentor_profile.bio))])])]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("\n                " + _vm._s(_vm._f("shortDate")(_vm.meeting.startTime)) + " — " + _vm._s(_vm._f("timeOnly")(_vm.meeting.endTime)) + "\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "conflicts"
  }, _vm._l((_vm.meeting.conflicts), function(conflict) {
    return _c('li', [_c('div', [_vm._v("\n                        You have a meeting scheduled at " + _vm._s(_vm._f("shortDate")(conflict.startTime)) + "\n                    ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "participants-wrapper"
  }, [_c('div', [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Attending: " + _vm._s(_vm.attending.length) + "/" + _vm._s(_vm.meeting.maxParticipants))]), _vm._v(" "), _c('ul', {
    staticClass: "participants attending"
  }, _vm._l((_vm.attending), function(participant) {
    return _c('li', [_vm._v("\n                            " + _vm._s(participant.user.firstName) + " " + _vm._s(participant.user.lastName) + " "), (participant.waitListed) ? _c('span', [_vm._v("(waitlist)")]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("Waitlist: " + _vm._s(_vm.waitListed.length))]), _vm._v(" "), _c('ul', {
    staticClass: "participants"
  }, _vm._l((_vm.waitListed), function(participant) {
    return _c('li', [_vm._v("\n                            " + _vm._s(participant.user.firstName) + " " + _vm._s(participant.user.lastName) + " "), (participant.waitListed) ? _c('span', [_vm._v("(waitlist)")]) : _vm._e()])
  }))])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', [_c('div', {
    staticClass: "error"
  }, [_c('i', {
    staticClass: "fa fa-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.errorMessage = null
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message"
  }, [_vm._v("\n                        " + _vm._s(_vm.errorMessage) + "\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.meeting.blocked) ? _c('div', {
    staticClass: "text-center red blocked"
  }, [_c('button', {
    staticClass: "btn btn-danger disabled"
  }, [_vm._v("LOCKED")]), _vm._v(" "), _c('p', [_vm._v("Unfortunately, it appears you missed a previous session without opting out in time.\n                Opting out in time is vital in order to assess the need of a session and therefor your account is temporarily locked.\n                Please submit a support ticket to unlock your account by clicking "), _c('a', {
    attrs: {
      "href": "/#/help"
    },
    on: {
      "click": function($event) {
        _vm.$emit('closeModal')
      }
    }
  }, [_vm._v("here")]), _vm._v(".")])]) : _c('div', {
    staticClass: "text-center"
  }, [(_vm.isParticipant) ? _c('button', {
    staticClass: "btn btn-danger",
    class: {
      'disabled': _vm.attendanceLocked
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSignup(false)
      }
    }
  }, [_vm._v("Opt Out")]) : _c('button', {
    staticClass: "btn btn-success",
    class: {
      'disabled': _vm.attendanceLocked
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleSignup(true)
      }
    }
  }, [_vm._v("Opt In")]), _vm._v(" "), (_vm.isParticipant && !_vm.isWaitListed) ? _c('a', {
    staticClass: "btn btn-success join",
    attrs: {
      "href": _vm.meeting.joinUrl,
      "target": "_blank"
    },
    on: {
      "mousedown": function($event) {
        _vm.recordAttendance(_vm.nextMeeting)
      }
    }
  }, [_vm._v("Join")]) : _vm._e(), _vm._v(" "), _vm._m(0)])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n                Opting in and out is locked 12 hours ahead of the session. Once opted in attendance is mandatory. You can only opt in to one meeting at a time. Make sure to opt out in case you can not attend. "), _c('b', [_vm._v("If you opt in and don't attend you'll be banned from opting in to future meetings.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://portal.tttc.ca/#/kb-article/42",
      "target": "_blank"
    }
  }, [_vm._v("Read our full rules here.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c777fb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GlobalMeetingSignup.vue
// module id = 2043
// module chunks = 2